import Experience from './Experience.js'

export default class App {

  constructor({ canvas, video }) {
    this.canvas = canvas
    this.video = video

    this.experience = new Experience(this.canvas, this.video)
  }
  
  destroy() {
    this.experience.destroy()
    this.experience = null
  }

}